/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { relevantRemovedRoots } from "./relevantRemovedRoots.js";
import { sequenceFieldChangeRebaser } from "./sequenceFieldChangeRebaser.js";
import { sequenceFieldChangeCodecFactory } from "./sequenceFieldCodecs.js";
import { sequenceFieldEditor } from "./sequenceFieldEditor.js";
import { sequenceFieldToDelta } from "./sequenceFieldToDelta.js";
import { createEmpty, getCrossFieldKeys, getNestedChanges, isEmpty } from "./utils.js";
export const sequenceFieldChangeHandler = {
    rebaser: sequenceFieldChangeRebaser,
    codecsFactory: sequenceFieldChangeCodecFactory,
    editor: sequenceFieldEditor,
    intoDelta: sequenceFieldToDelta,
    relevantRemovedRoots,
    isEmpty,
    getNestedChanges,
    createEmpty,
    getCrossFieldKeys,
};
//# sourceMappingURL=sequenceFieldChangeHandler.js.map